module.exports = __webpack_public_path__ + "static/media/navy.f3084ef1.png";